<template>
<div class="chapter">
<div class="inner_page">
<div class="part">
<div class="title-part"><a href="#/e9781466815223_toc01#toctitle1" id="title1"><span><em class="i"><strong class="b">Zeke</strong></em></span></a></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466815223_p01.vue?ce61b376